import { useEffect, useRef } from 'react';

import { appConfig, Environment } from '@app/config/appConfig';
import { initializePendo } from '@app/pendo/pendoInitializer';
import { loadPendoScript } from '@app/pendo/pendoLoader';
import type { User } from '@features/user-management';

export const usePendo = (user?: User) => {
  const isLoaded = useRef(false);

  useEffect(() => {
    //TODO: Enable in PROD when we know what to track
    if (!user?.email || isLoaded.current || appConfig.environment === Environment.PROD) return;

    const apiKey = appConfig.thirdParties.pendoApiKey;
    const nonce = appConfig.cspNonce;

    if (!apiKey) return;

    isLoaded.current = true;

    const visitor = {
      id: user.email || 'guest',
      email: user.email,
      roles: user.roles,
    };
    const account = {
      id: user.email || 'default',
    };

    loadPendoScript(apiKey, nonce)
      .then(() => {
        if (globalThis.pendo) {
          initializePendo(visitor, account);
        }
        return null;
      })
      .catch(() => {
        isLoaded.current = false;
        return null;
      });
  }, [user?.email, user?.roles]);
};
